<section>
  <flight-map
    [origin]="formattedOrigin"
    [destination]="formattedDestination"
  ></flight-map>
</section>
